import type { JobRunSummaryDto, JobStepDto } from '@/api/generated/schemas';

/**
 * Typová mapa SSE eventů (server → klient, viz backend.12.realtime.md).
 * Nový event = přidej řádek sem + do `SSE_EVENT_TYPES` — transport (`sseClient`) se nemění,
 * handlery vlastní jednotlivé slices přes `sseEmitter.on(...)`.
 *
 * Payloady jsou JSON serializované backendové event recordy (camelCase). Tvary `job:completed`
 * a `job:step-failed` jsou zatím psané ručně — backend je nevystavuje jako OpenAPI komponenty
 * (SSE stream není v openapi.json); drží je integrační scénář e2e.
 */
export type SseEventMap = {
  'job:run-changed': { run: JobRunSummaryDto };
  'job:step-changed': { runId: string; revision: number; step: JobStepDto };
  'job:completed': {
    runId: string;
    revision: number;
    succeeded: boolean;
    title: string;
    totalSteps: number;
    failedSteps: number;
    durationMs: number;
  };
  'job:step-failed': {
    runId: string;
    revision: number;
    stepId: string;
    stepName: string;
    title: string;
  };
  /** Interní lifecycle transportu — po (re)connectu si konzumenti refetchnou stav. */
  'sse:connected': { reconnected: boolean };
};

/** Pojmenované SSE eventy, na které transport věší `addEventListener` (bez interních `sse:*`). */
export const SSE_EVENT_TYPES = [
  'job:run-changed',
  'job:step-changed',
  'job:completed',
  'job:step-failed',
] as const satisfies readonly (keyof SseEventMap)[];

export type SseServerEventType = (typeof SSE_EVENT_TYPES)[number];
